import React from "react";
import Modal, { Styles } from "react-modal";

import { modalStyles } from "../styles";
import Button from "components/common/Button";
import { Headline3 } from "components/common/styles";
import {
  IconWrapper,
  InfoWrapper,
  InfoPara,
  ButtonGroup,
  ContentWrapper
} from "./styles";

export interface IDecisionDialogAction {
  label: string;
  variant?: string;
  onClick?: () => void;
}

export interface IDecisionDialogProps {
  isOpen: boolean;
  title: string;
  description?: string;
  icon?: React.ReactNode;
  actions: IDecisionDialogAction[];
  onRequestClose: () => void;
}

const DecisionDialog: React.FC<IDecisionDialogProps> = ({
  isOpen,
  title,
  description,
  icon,
  actions,
  onRequestClose
}) => {
  const styles = modalStyles(360) as Styles;
  styles.overlay!.zIndex = 11;

  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      style={styles}
      onRequestClose={onRequestClose}
    >
      <InfoWrapper>
        {icon && <IconWrapper>{icon}</IconWrapper>}
        <ContentWrapper>
          <Headline3>{title}</Headline3>
          {description && <InfoPara>{description}</InfoPara>}
        </ContentWrapper>
        <ButtonGroup>
          {actions.map(action => (
            <Button
              key={action.label}
              variant={action.variant ?? "secondary"}
              onClick={action.onClick}
            >
              {action.label}
            </Button>
          ))}
        </ButtonGroup>
      </InfoWrapper>
    </Modal>
  );
};

export default DecisionDialog;
